'use client';
import { isString } from '@s7/utils';
import { TransitionPresets } from '../presets.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const TRANSITION_STATUS = {
    entering: 'in',
    entered: 'in',
    exiting: 'out',
    exited: 'out',
    'pre-exiting': 'out',
    'pre-entering': 'out'
};
function expandTransition({ transition, state, duration, timingFunction }) {
    const shared = {
        transitionDuration: `${duration}ms`,
        transitionTimingFunction: timingFunction
    };
    if (isString(transition)) {
        if (!(transition in TransitionPresets)) {
            return {};
        }
        return _extends({
            transitionProperty: TransitionPresets[transition].transitionProperty
        }, shared, TransitionPresets[transition].common, TransitionPresets[transition][TRANSITION_STATUS[state]]);
    }
    return _extends({
        transitionProperty: transition.transitionProperty
    }, shared, transition.common, transition[TRANSITION_STATUS[state]]);
}

export { expandTransition };
//# sourceMappingURL=expandTransition.js.map
